import {
  GET_DISTRICT_LIST_FAIL,
  GET_DISTRICT_LIST_REQUEST,
  GET_DISTRICT_LIST_SUCCESS,
} from "src/constants/types";

export const districtReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_DISTRICT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_DISTRICT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        districts: actions.payload,
        error: "",
      };

    case GET_DISTRICT_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
